module.exports = __webpack_public_path__ + "media/packs/images/flags/SA-c221716d18f53e6ad2a6db46dc2ee2eb.png";